import exifjs from 'exif-js';

const load = src => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
};

const fromFile = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => load(reader.result).then(image => resolve(image));
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const exif = img => {
  return new Promise(resolve => {
    exifjs.getData(img, () => resolve(exifjs.getAllTags(img)));
  });
};

const reorient = (img, orientation, contentType = 'image/png') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const { width, height } = img;
  const flip = orientation > 4;
  const transformations = {
    1: () => context.transform(1, 0, 0, 1, 0, 0),
    2: () => context.transform(-1, 0, 0, 1, width, 0), // horizontal flip
    3: () => context.transform(-1, 0, 0, -1, width, height), // 180° rotate left
    4: () => context.transform(1, 0, 0, -1, 0, height), // vertical flip
    5: () => context.transform(0, 1, 1, 0, 0, 0), // vertical flip + 90 rotate right
    6: () => context.transform(0, 1, -1, 0, height, 0), // 90° rotate right
    7: () => context.transform(0, -1, -1, 0, height, width), // horizontal flip + 90 rotate right
    8: () => context.transform(0, -1, 1, 0, 0, width), // 90° rotate left
  };

  canvas.width = flip ? height : width;
  canvas.height = flip ? width : height;
  transformations[orientation]();
  context.drawImage(img, 0, 0);

  return load(canvas.toDataURL(contentType));
};

const crop = async (
  src,
  cropX,
  cropY,
  cropWidth,
  cropHeight,
  srcWidth,
  srcHeight,
  backgroundColor,
  contentType = 'image/png'
) => {
  const image = await load(src);

  const source = document.createElement('canvas');
  const sourceContext = source.getContext('2d');
  source.width = srcWidth;
  source.height = srcHeight;

  sourceContext.drawImage(image, 0, 0, srcWidth, srcHeight);
  const imageData = sourceContext.getImageData(
    cropX,
    cropY,
    cropWidth,
    cropHeight
  );

  const cropped = document.createElement('canvas');
  const croppedContext = cropped.getContext('2d');
  cropped.width = cropWidth;
  cropped.height = cropHeight;
  croppedContext.putImageData(imageData, 0, 0);

  const target = document.createElement('canvas');
  const targetContext = target.getContext('2d');
  target.width = cropWidth;
  target.height = cropHeight;

  if (backgroundColor) {
    targetContext.fillStyle = backgroundColor;
    targetContext.fillRect(0, 0, cropWidth, cropHeight);
  }
  targetContext.drawImage(cropped, 0, 0);

  return target.toDataURL(contentType);
};

const toFile = async (base64, filename = '', fetchOptions = {}) => {
  const res = await fetch(base64, fetchOptions);
  const blob = await res.blob();
  return new File([blob], filename, {
    type: blob.type,
  });
};

export { load, fromFile, exif, reorient, crop, toFile };
